module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperPearlescent-4204ad670aa693aac048c9264cd3f250.jpg";